import { Component, OnInit } from '@angular/core';
import { TFMService } from 'app/mock-api/tfm.service';
import { Title, Meta } from '@angular/platform-browser';

import { LeisureTravelType01Component } from './leisure-travel-type01/leisure-travel-type01.component';
import { LeisureTravelType02Component } from './leisure-travel-type02/leisure-travel-type02.component';
import { CountersType01Component } from "../counter/counters-type01/counters-type01.component";
import { XlLeisureTravelComponent } from './xl-leisure-travel/xl-leisure-travel.component';

@Component({
  selector: 'app-leisure-travel',
  standalone: true,
  imports: [LeisureTravelType01Component, LeisureTravelType02Component, CountersType01Component, XlLeisureTravelComponent],
  templateUrl: './leisure-travel.component.html',
  styleUrl: './leisure-travel.component.scss'
})
export class LeisureTravelComponent implements OnInit {

  public view: any = {

  }

  constructor(private _tfmService: TFMService, private title: Title, private metaService: Meta){}

  ngOnInit(): void {

    this._tfmService.getSite().then(res => {
      this.view.site = res;
      // console.log('Site: ', this.view.site);

      if (this.view.site) {
        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);
      }

    });

    this._tfmService.getContentBySection('leisure-travel').then(res => {
      this.view.page = res;
      // console.log('Page: ', this.view.page);

      if (this.view.page && this.view.site) {

        //Set title
        this.title.setTitle(this.view.page.content.name + " - " + this.view.site.name);

        // Set description & keywords
        this.metaService.updateTag( { name:'description', content:this.view.page.content.seo.description});
        this.metaService.updateTag( { name:'keywords', content:this.view.page.content.seo.keywords});
      }
    });
      
  }

}
